import React from 'react';
import { Buttons, CancelButton, DeleteButton, FormMessage, ModalCard } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import { useForm } from '~/hooks';

export default function DeleteDataConfirmation({ onDelete, onClose }) {
  const [{ isSubmitting, message, status }, form] = useForm();
  const api = useApi();
  const { workspace } = useWorkspace();

  const handleSubmit = async (scope) => {
    form.submit(scope);

    try {
      await api.www.workspaces(workspace.id).bamboohr.deleteData();

      onDelete();
      onClose();
      form.done();
    } catch ({ message }) {
      form.error({ message });
    }
  };

  return (
    <ModalCard title="Remove imported time off entries" onClose={onClose}>
      <ModalCard.Body>
        {status && <FormMessage.Error style={{ marginBottom: '1rem' }}>{message}</FormMessage.Error>}
        This will remove <strong>all time off data imported from BambooHR</strong> from this workspace. Are you sure?
      </ModalCard.Body>
      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={onClose}>Cancel</CancelButton>
          <DeleteButton isLoading={isSubmitting} onClick={handleSubmit}>
            Delete
          </DeleteButton>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}
